import { render, staticRenderFns } from "./CollapsedSection.vue?vue&type=template&id=1fcf9e72&scoped=true"
import script from "./CollapsedSection.vue?vue&type=script&lang=js"
export * from "./CollapsedSection.vue?vue&type=script&lang=js"
import style0 from "./CollapsedSection.vue?vue&type=style&index=0&id=1fcf9e72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcf9e72",
  null
  
)

export default component.exports